import { render, staticRenderFns } from "./BaseFilter.vue?vue&type=template&id=72143412&scoped=true"
import script from "./BaseFilter.vue?vue&type=script&lang=js"
export * from "./BaseFilter.vue?vue&type=script&lang=js"
import style0 from "./BaseFilter.vue?vue&type=style&index=0&id=72143412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72143412",
  null
  
)

export default component.exports